<template>
  <component
    :key="item.key"
    v-bind="item.props"
    :is="getComponent(item.component)"
    :value="get($path('props.key', item) || item.key)"
    :data-field="item.key"
    :disabled="Boolean(item.disabled || getDisabledField(item.key))"
    @input="$ev => set($path('props.key', item) || item.key, $ev)"
    :validator="validator"
    v-tooltip.bottom="item.disabled || getDisabledField(item.key)"
  >
    <template v-for="(slotItems, slot) in item.slots" v-slot:[slot]="slotScope">
      <component
        v-for="(slotItem, index) of slotItems"
        :key="item.key + slot + index"
        v-bind="{ ...slotItem.props, ...slotScope }"
        :is="getComponent(slotItem.component)"
        :value="$path('props.value', slotItem) || get(item.key)"
        :disabled="Boolean(getDisabledField(item.key))"
        @input="$ev => set($path('props.value', slotItem) || get(slotItem.key), $ev)"
      />
    </template>
  </component>
</template>

<script>
import { mapGetters } from 'vuex'
import { setByPath } from '@/utils'
import { InputComponent } from 'vue-elder-input'
import Radio from '@kvass/custom-fields/src/Fields/Radio'
import Tags from '@kvass/custom-fields/src/Fields/Tags'
import Select from '@kvass/custom-fields/src/Fields/Select'
import ThemeSelector from './ThemeSelector.vue'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    placement: {
      type: String,
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters('ModelTemplate', ['getDisabledField']),
  },
  methods: {
    get(key) {
      if (!key) return

      return this.$path(key, this.value)
    },

    set(key, value) {
      const oldValue = this.get(key)

      if (key === 'ofType' && oldValue !== value) {
        if (value === 'Project') {
          setByPath('data.theme', null, this.value)
        }
        if (value === 'Page') {
          setByPath('data.theme', { template: null }, this.value)
        }
      }

      setByPath(key, value, this.value)
    },

    getComponent(item) {
      const items = {
        Input: InputComponent,
        Radio,
        Tags,
        Select,
        ThemeSelector,
      }

      return items[item] || item
    },
  },
}
</script>

<style lang="scss"></style>
